<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav>
        <h4 class="mb-0">{{ title }}</h4>
      </b-navbar-nav>
    </b-navbar>

    <b-list-group id="catalog_list" class="">
      <b-list-group-item
        v-for="(item, index) in catalogs"
        :key="index"
      >
        <h5>{{ item.name }}</h5>

        <b-list-group id="catalog-items-list" class="text-small list-group-striped">
          <b-list-group-item
            v-for="(item, index) in item.items"
            :key="index"
            v-if="hasPermission(item.perms)"
            :to="{ path: item.path}"
          >
            <font-awesome-icon icon="list" style="color: black" class="mr-1"/>
            {{ item.name }}
          </b-list-group-item>
        </b-list-group>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import permissions from "../../utilites/permissions";
import {PERM} from "../../utilites/permissions";

export default {
  name: "CatalogList",
  mixins: [permissions],
  data() {
    return {
      title: 'Справочники',
      catalogs: this.getCatalogs(),
    };
  },
  methods: {
    getCatalogs() {
      return [
        {
          name: 'Общие',
          items: [
            {
              name: 'Города',
              perms: [PERM.CATALOG_TOWN],
              path: '/town_catalogs'
            },
            {
              name: 'Маркетинговые источники',
              perms: [PERM.CATALOG_SOURCE],
              path: '/marketing_sources'
            },
            {
              name: 'Подразделения',
              perms: [PERM.CATALOG_DEPARTMENT],
              path: '/departments'
            },
            {
              name: 'Должности',
              perms: [PERM.CATALOG_JOB_TITLE],
              path: '/job_titles'
            },
            {
              name: 'Статусы проектов',
              perms: [PERM.CATALOG_PROJECT_STATUS],
              path: '/project_statuses'
            },
            {
              name: 'Статусы лидов',
              perms: [PERM.CATALOG_LEAD_STATUS],
              path: '/lead_statuses'
            },
            {
              name: 'Статусы заказчиков',
              perms: [PERM.CATALOG_CUSTOMER_STATUS],
              path: '/customer_statuses'
            },
            {
              name: 'Источники лидов',
              perms: [PERM.CATALOG_LEAD_SOURCE],
              path: '/lead_sources'
            },
          ]
        },
        {
          name: 'Исполнители',
          items: [
            {
              name: 'Гражданства',
              perms: [PERM.CATALOG_CITIZENSHIPS],
              path: '/citizenships'
            },
            {
              name: 'Источники исполнителей',
              perms: [PERM.CATALOG_WORKER_SOURCE],
              path: '/worker_sources'
            },
            {
              name: 'Статусы исполнителей',
              perms: [PERM.CATALOG_WORKER_STATUS],
              path: '/worker_statuses'
            },
            {
              name: 'Категория занятости',
              perms: [PERM.CATALOG_EMPLOYMENT_CATEGORY],
              path: '/employment_categories'
            },
            {
              name: 'Категории водительских прав',
              perms: [PERM.CATALOG_DRIVER_LICENSE_CATEGORY],
              path: '/driver_license_categories'
            },
            {
              name: 'Типы расходов исполнителя',
              perms: [PERM.CATALOG_WORKER_COST_TYPE],
              path: '/worker_cost_types'
            },
            {
              name: 'Вакансии',
              perms: [PERM.CATALOG_VACANCY],
              path: '/vacancies'
            },
            {
              name: 'Теги заявки на подбор',
              perms: [PERM.CATALOG_RECRUIT_TAG],
              path: '/recruit_tags'
            },
            {
              name: 'Умения исполнителей',
              perms: [PERM.CATALOG_WORKER_SKILLS],
              path: '/worker_skills'
            },
            {
              name: 'Нарекания исполнителей',
              perms: [PERM.CATALOG_WORKER_COMPLAINTS],
              path: '/worker_complaints'
            },
          ]
        },
        {
          name: 'Объекты',
          items: [
            {
              name: 'Виды работ',
              perms: [PERM.CATALOG_WORK_TYPE],
              path: '/work_type_catalogs'
            },
            {
              name: 'Типы расходов объекта',
              perms: [PERM.CATALOG_LOCATION_COST_TYPE],
              path: '/location_cost_types'
            },
            {
              name: 'Статусы объекта',
              perms: [PERM.CATALOG_LOCATION_STATUS],
              path: '/location_statuses'
            },
            {
              name: 'Услуги самозанятых',
              perms: [PERM.CATALOG_WORK_SERVICE],
              path: '/work_services'
            },
          ]
        },
        {
          name: 'Заявки',
          items: [
            {
              name: 'Статус исполнителя в заявке',
              perms: [PERM.CATALOG],
              path: '/task_worker_statuses'
            },
          ]
        },
      ]

    },
  }
}
</script>

<style scoped>
.list-group-striped .list-group-item:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.05);
}

.list-group-striped .list-group-item:nth-child(even):hover {
  background-color: rgba(0, 0, 0, 0.075);
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/CatalogList.vue